import React, { useCallback, ComponentProps } from 'react';
import { PaymentSource } from '../../constants';
import { useCart } from '../../hooks/useCart';
import { PayPalButton } from '../PaymentSourceButton';
import { useChangePaymentSource } from './useChangePaymentSource';

type Props = Omit<ComponentProps<typeof PayPalButton>, 'paypalClientToken' | 'onSelect'>;

export const CheckoutPayPalButton: React.FC<Props> = props => {
  const {
    cart: {
      attributes: { paypalClientToken }
    }
  } = useCart();

  const changePaymentSource = useChangePaymentSource();

  const onSelect = useCallback(() => changePaymentSource(PaymentSource.PayPal), [
    changePaymentSource
  ]);

  return <PayPalButton {...props} paypalClientToken={paypalClientToken} onSelect={onSelect} />;
};
